export default __webpack_public_path__ + "static/media/pac.4f24953d.JPG";